import { VideoHighlightProps } from "interfaces/ExternalPage/SpeakerLandingPage.interface";
// import { useState } from "react";

// Video Highlight Component
export default function VideoHighlight({
  videoUrl,
  thumbnail,
}: VideoHighlightProps) {
  // const [isPlaying, setIsPlaying] = useState(false);

  // Convert YouTube URL to embed URL
  const getEmbedUrl = (url: string | undefined): string | null => {
    if (!url) return null;

    // If already an embed URL, return as is
    if (url.includes("youtube.com/embed/")) {
      return url;
    }

    // Extract video ID and create embed URL
    const videoId = getYouTubeVideoId(url);
    if (!videoId) return null;

    return `https://www.youtube.com/embed/${videoId}?autoplay=0`;
  };

  const embedUrl = getEmbedUrl(videoUrl);

  return (
    <section className="mx-auto mt-[40px] sm:mt-[60px]">
      <div
        className="relative w-full h-[300px] sm:h-[400px] lg:h-[500px] rounded-xl sm:rounded-3xl overflow-hidden group cursor-pointer"
        // onClick={() => setIsPlaying(true)}
      >
        {embedUrl && (
          <div className="absolute inset-0 z-10">
            <iframe
              src={embedUrl}
              title="Speaker highlight video"
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        )}
      </div>
    </section>
  );
}

// Helper function to extract YouTube video ID from URL
function getYouTubeVideoId(url: string): string | null {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
}
